import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { ApiMethods, CuredApiPaths } from 'models/enums';
import useMutation from 'hooks/useMutation';
import MutationKeys from 'hooks/mutations/keys';
import QueryKeys from 'hooks/queries/keys';
import type { AssignUserRoleApiResponse } from 'domains/accessCentre/types';

export type AssignUserRoleInput = {
    roleId: number;
};

const useAssignUserRole = (
    userId: string,
    mutateOptions?: UseMutationOptions<AssignUserRoleApiResponse, Error, AssignUserRoleInput>
) => {
    const queryClient = useQueryClient();
    const path = `${CuredApiPaths.ACCESS_CENTRE_USERS}/${userId}/role`;

    const { onSuccess: onSuccessOption, ...restMutateOptions } = mutateOptions ?? {};

    return useMutation<AssignUserRoleInput, AssignUserRoleApiResponse>(
        MutationKeys.ASSIGN_USER_ROLE(userId),
        path,
        {
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(QueryKeys.ACCESS_CENTRE_USER_ID(userId));
                queryClient.invalidateQueries(['access-centre', 'users']);
                onSuccessOption?.(data, variables, context);
            },
            ...restMutateOptions,
        },
        ApiMethods.PUT
    );
};

export default useAssignUserRole;
